var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.3 196.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #7AF365;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.7,196.7l28.1-16.6c28.9-17.1,44.5-31.7,44.5-65.7s-15.6-48.6-44.5-65.7l-28.1-16.6v32l11.5,6.7c18.4,10.7,34,20.2,34,43.7s-15.6,33-34,43.7l-11.5,6.7v32h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.7,164.7v-32l-11.5-6.7c-18.4-10.7-34-20.2-34-43.7s15.6-33,34-43.7l11.5-6.7V0l-28.1,16.6C15.6,33.8,0,48.4,0,82.4s15.6,48.6,44.5,65.7l28.1,16.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.289eb9e4dd6c035889a6d984c0d4dd5a.svg";
export { ForwardRef as ReactComponent };